module.exports = __webpack_public_path__ + "static/media/placeholder-1.28a8f74a.svg";